import APIResponse from '../models/APIResponse';

export default function isSessionExpired<T>(response?: APIResponse<T>): boolean {
    return (response?.status !== "OK" && response?.statusMessage === "Session has expired. Please log back in.");
}
